export default {
      id: "icon-buy-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "assets/template/sprite/sprite.svg#icon-buy",
      toString: function () {
        return this.url;
      }
    }